// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hide-item ::ng-deep app-item .item-box {
  display: none;
}
.hide-item ::ng-deep app-item .item-box-hidding {
  display: block !important;
}

ion-item {
  --padding-start: 3px;
  --padding-end: 0px;
  --inner-padding-end: 0px;
}

.title {
  overflow: auto;
  white-space: pre-line;
}

ion-card-subtitle.price {
  text-align: end;
  font-size: 22px;
}

ion-card-title {
  font-size: 15px;
}

ion-card {
  margin: 5px;
}

ion-badge {
  position: absolute;
  right: 5px;
  top: 5px;
  --background: var(--button-a-background);
  --color: var(--button-a-text);
}

.comments-box {
  font-size: 13px;
}

.price-size {
  font-size: 14px;
}
.price-size ion-icon {
  vertical-align: middle;
}

.details-box {
  padding: 0 3px;
}

.props-box {
  line-height: 1.2;
  font-size: 14px;
}
.props-box .title {
  font-weight: bold;
}
.props-box .props span {
  font-style: italic;
}

.maker-img {
  width: -moz-fit-content;
  width: fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
}
.maker-img img {
  max-width: 25px;
  height: auto;
}

.card-background-page ion-card {
  position: relative;
  text-align: center;
}
.card-background-page .card-title {
  position: absolute;
  top: 10%;
  font-size: 2em;
  width: 100%;
  font-weight: bold;
  color: #fff;
}
.card-background-page .card-subtitle {
  font-size: 1em;
  position: absolute;
  top: 32%;
  width: 100%;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/cart/components/cart-item/cart-item.component.scss"],"names":[],"mappings":"AAGM;EACE,aAAA;AAFR;AAIM;EACE,yBAAA;AAFR;;AAQA;EACE,oBAAA;EACA,kBAAA;EACA,wBAAA;AALF;;AAQA;EACE,cAAA;EACA,qBAAA;AALF;;AAaA;EACE,eAAA;EACA,eAAA;AAVF;;AAaA;EACE,eAAA;AAVF;;AAaA;EACE,WAAA;AAVF;;AAkBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EAEA,wCAAA;EACA,6BAAA;AAhBF;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACE,eAAA;AAhBF;AAkBE;EACE,sBAAA;AAhBJ;;AAoBA;EACE,cAAA;AAjBF;;AAqBA;EACE,gBAAA;EACA,eAAA;AAlBF;AAoBE;EACE,iBAAA;AAlBJ;AAwBI;EACE,kBAAA;AAtBN;;AAiCA;EAOE,uBAAA;EAAA,kBAAA;EACA,2BAAA;EAAA,sBAAA;AApCF;AAsCE;EACE,eAAA;EACA,YAAA;AApCJ;;AA0CE;EACE,kBAAA;EACA,kBAAA;AAvCJ;AA0CE;EACE,kBAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;AAxCJ;AA2CE;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAzCJ","sourcesContent":[".hide-item{\n  ::ng-deep {\n    app-item {\n      .item-box{\n        display: none;\n      }\n      .item-box-hidding{\n        display: block !important;\n      }\n    }\n  }\n}\n\nion-item {\n  --padding-start: 3px;\n  --padding-end: 0px;\n  --inner-padding-end: 0px;\n}\n\n.title {\n  overflow: auto;\n  white-space: pre-line;\n}\n\n//.price\n//{\n//  font-weight: bold;\n//}\n\nion-card-subtitle.price {\n  text-align: end;\n  font-size: 22px;\n}\n\nion-card-title {\n  font-size: 15px;\n}\n\nion-card {\n  margin: 5px;\n}\n\n.cart-btn {\n  //max-width: 40px;\n}\n\n\nion-badge {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n\n  --background: var(--button-a-background);\n  --color: var(--button-a-text);\n}\n\n.comments-box {\n  font-size: 13px;\n}\n\n.price-size {\n  font-size: 14px;\n\n  ion-icon{\n    vertical-align: middle;\n  }\n}\n\n.details-box {\n  padding: 0 3px;\n}\n\n\n.props-box {\n  line-height: 1.2;\n  font-size: 14px;\n\n  .title {\n    font-weight: bold;\n  }\n\n  .props {\n    //padding: 0 5px;\n\n    span {\n      font-style: italic;\n    }\n  }\n}\n\n.inner-items-box {\n  //box-shadow: 1px 0px 2px #949494;\n  //margin: 10px 0;\n  //padding: 3px;\n}\n\n.maker-img {\n  //position: absolute;\n  //bottom: 0;\n  //left: 0;\n  //background: #fff;\n  //padding: 1px;\n\n  width: fit-content;\n  max-width: fit-content;\n\n  img {\n    max-width: 25px;\n    height: auto;\n  }\n}\n\n.card-background-page {\n\n  ion-card {\n    position: relative;\n    text-align: center;\n  }\n\n  .card-title {\n    position: absolute;\n    top: 10%;\n    font-size: 2.0em;\n    width: 100%;\n    font-weight: bold;\n    color: #fff;\n  }\n\n  .card-subtitle {\n    font-size: 1.0em;\n    position: absolute;\n    top: 32%;\n    width: 100%;\n    color: #fff;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
